var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M10.63 0C4.76 0 0 4.76 0 10.63c0 5.87 4.76 10.63 10.63 10.63 5.87 0 10.63-4.76 10.63-10.63C21.26 4.76 16.5 0 10.63 0",
    transform: "translate(.083 1.006)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M12.375 10.63c0 .964-.782 1.744-1.745 1.744-.964 0-1.745-.78-1.745-1.744s.781-1.744 1.745-1.744c.963 0 1.745.78 1.745 1.744M17.32 15.08c0 .965-.781 1.745-1.744 1.745-.964 0-1.745-.78-1.745-1.744s.78-1.745 1.745-1.745c.963 0 1.744.78 1.744 1.745",
    transform: "translate(.083 1.006)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.b9f1bb7e619ff4e111ccdcb1c9eea7cb.svg";
export { ForwardRef as ReactComponent };